<template>
    <popout
        :show="show"
        :title="$t('jobs.sharing.title')"
        full-width
        icon="share"
        @close="$emit('close')"
    >
        <share-job v-if="job" :job="job"></share-job>
    </popout>
</template>

<script>
import Popout from './ui/Popout';
import Job from '../models/Job';
import ShareJob from './ShareJob';

export default {
    components: {
        ShareJob,
        Popout,
    },
    props: {
        show: Boolean,
        job: Job,
    },
};
</script>